import { Link } from "react-router-dom";
import { AiOutlineFilePdf, AiOutlinePicture, AiOutlineVideoCamera } from "react-icons/ai"; // MIT License
import { GiPathDistance } from "react-icons/gi"

export default function AddVisualization(props) {
  return (
    <>
      <div class='container py-8 px-8 mx-0 min-w-full bg-gray-50 border shadow rounded-xl dark:bg-gray-800 dark:border-gray-700'>
        <h2 className="text-base font-semibold leading-7 text-gray-900 pb-2 border-b border-gray-200 dark:text-white dark:border-gray-700">Select a type of visualization to add</h2>
        <div className='flex items-center justify-center flex-wrap mt-4'>
          <Link to={`/visualization/upload-image`} class='focus:outline-none mx-5 my-3'>
            <div data-cy="image" className="h-30 w-32 p-2 bg-gray-100 rounded border hover:bg-gray-200 dark:hover:bg-gray-700 dark:bg-gray-600 dark:border-gray-500">
              <div className="mx-auto flex items-center justify-center">
                <AiOutlinePicture className="mb-4 mt-1 h-14 w-14 text-gray-400 dark:text-white" aria-hidden="true" />
              </div>
              <div className="text-center">
                <p className="bg-green-500 p-0.5 rounded text-xs text-white font-semibold text-center">
                  Image
                </p>
              </div>
            </div>
          </Link>
          <Link to={`/visualization/upload-video`} class='focus:outline-none mx-5 my-3'>
            <div data-cy="video" className="h-30 w-32 p-2 bg-gray-100 rounded border hover:bg-gray-200 dark:hover:bg-gray-700 dark:bg-gray-600 dark:border-gray-500">
              <div className="mx-auto flex items-center justify-center">
                <AiOutlineVideoCamera className="mb-4 mt-1 h-14 w-14 text-gray-400 dark:text-white" aria-hidden="true" />
              </div>
              <div className="text-center">
                <p className="bg-blue-500 p-0.5 rounded text-xs text-white font-semibold text-center">
                  Video
                </p>
              </div>
            </div>
          </Link>


          <Link to={`/visualization/upload-pdf`} class='focus:outline-none mx-5 my-3'>
            <div data-cy="pdf" className="h-30 w-32 p-2 bg-gray-100 rounded border hover:bg-gray-200 dark:hover:bg-gray-700 dark:bg-gray-600 dark:border-gray-500">
              <div className="mx-auto flex items-center justify-center">
                <AiOutlineFilePdf className="mb-4 mt-1 h-14 w-14 text-gray-400 dark:text-white" aria-hidden="true" />
              </div>
              <div className="text-center">
                <p className="bg-red-500 p-0.5 rounded text-xs text-white font-semibold text-center">
                  PDF
                </p>
              </div>
            </div>
          </Link>

          <Link to={`/visualization/upload-gpx`} class='focus:outline-none mx-5 my-3'>
            <div data-cy="gpx" className="h-30 w-32 p-2 bg-gray-100 rounded border hover:bg-gray-200 dark:hover:bg-gray-700 dark:bg-gray-600 dark:border-gray-500">
              <div className="mx-auto flex items-center justify-center">
                <GiPathDistance className="mb-4 mt-1 h-14 w-14 text-gray-400 dark:text-white" aria-hidden="true" />
              </div>
              <div className="text-center">
                <p className="bg-yellow-800 p-0.5 rounded text-xs text-white font-semibold text-center">
                  GPX/GeoJSON
                </p>
              </div>
            </div>
          </Link> 
        </div>
      </div>
    </>
  )
}
